export default __webpack_public_path__ + "static/media/beach.3349d057.jpg";